import React, { useEffect, useContext, useState, useRef } from 'react'
import { v4 as uuidv4 } from 'uuid';

import {
  Box,
  Button,
  TextField,
  InputAdornment,
} from '@material-ui/core';

import APIS from "../../utils/APIS"

import LanguageContext from "../../contexts/LanguageContext"
import PopupNotifContext from "../../contexts/PopupNotifContext"

import closeIcon from '../../images/closeIcon.svg';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import accountIcon from "../../images/accountIcon.svg"
import simpleArrowIcon from "../../images/simpleArrowIcon.svg"
import rectBlackCheckWhite from "../../images/rectBlackCheckWhite.svg"


const PageContainer = ({ children, onCloseModal, setPage, title, onSave, disabledButton, noButton}) => {

  const {
    actLanguage,
    languageValues,
  } = useContext(LanguageContext)

 return (
   <>
     <Box sx={{
       display:"flex",
       flexDirection:"row",
       justifyContent:"space-between",
       borderBottom:["1px solid #EFEFEF", 0],
     }}>
       <img
         src={simpleArrowIcon}
         style={{width:"20px", height:"20px", cursor:"pointer", transform:"rotate(180deg)",}}
         onClick={() => { setPage("select") }}
         />
       <Box sx={{
         display:"flex",
         flexDirection:"column",
         alignItems:"center",
         gap:"5px",
         marginBottom:"15px",
       }}>
         <Box sx={{
           fontSize:"14px",
           color:"text.subTitle",
         }}>
           {languageValues?.myAccount?.title[actLanguage]}
         </Box>
         <Box sx={{
           fontSize:"17px",
           color:"text.black",
         }}>
           {title}
         </Box>
       </Box>
       <img
         src={closeIcon}
         style={{width:"18px", height:"18px", cursor:"pointer"}}
         onClick={onCloseModal}
       />
     </Box>
     <Box sx={{
       marginTop:"20px",
       flex:1,
       display:"flex",
       flexDirection:"column",
     }}>
       <Box sx={{
         flex:1,
       }}>
         {children}
       </Box>
       {noButton !== true &&
         <Box sx={{
           paddingTop:"20px",
         }}>
           <Button
             disabled={disabledButton}
             color="primary"
             fullWidth
             size="large"
             type="submit"
             variant="contained"
             onClick={onSave}
           >
             {languageValues?.save[actLanguage]}
           </Button>
         </Box>
       }
     </Box>
   </>
 )
}

const MyAccount = ({ actUser, updateUserContext, onCloseModal, page, setPage }) => {

  const { addPopupNotif } = useContext(PopupNotifContext)

  const {
    actLanguage,
    languageValues,
    allLanguages,
    changeLanguage,
  } = useContext(LanguageContext)

  const [showPassword, setShowPassword] = useState(false)

  const [newName, setNewName] = useState("")
  const [newPoste, setNewPoste] = useState("")
  const [changeNamesSubmitting, setChangeNamesSubmitting] = useState(false)

  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("")
  const [changePasswordSubmitting, setChangePasswordSubmitting] = useState(false)

  const [changeLanguageSubmitting, setChangeLanguageSubmitting] = useState(false)

  useEffect(() => {
    if (actUser) {
      setNewName(actUser?.name)
      setNewPoste(actUser?.poste || "")
    }
  }, [actUser, page])

  return (
    <>
      {page === "select" &&
        <>
          <Box sx={{
            display:"flex",
            flexDirection:"column",
          }}>
            <Box sx={{
              display:"flex",
              justifyContent:"flex-end"
            }}>
              <img
                src={closeIcon}
                style={{width:"18px", height:"18px", cursor:"pointer"}}
                onClick={onCloseModal}
              />
            </Box>
            <Box sx={{
              fontSize:"30px",
              color:"text.black",
              textAlign:"center",
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:"10px",
            }}>
              <Box sx={{
                width:"100px",
              }}>
                <img src={accountIcon} style={{width:"100%"}}/>
              </Box>
              {actUser?.name}
              <Box sx={{
                fontSize:"16px",
                color:"text.black",
                textAlign:"center",
              }}>
                {actUser?.poste}
              </Box>
            </Box>
          </Box>
          <Box sx={{
            marginTop:"45px",
          }}>
            <Button
              disableRipple
              fullWidth
              onClick={() => { setPage("name") }}
              sx={{
                fontSize:"16px",
                color:"text.black",
                minWidth:0,
                borderBottom:"1px solid #EFEFEF",
                justifyContent:"space-between",
                "&:hover" : {
                  background:"transparent",
                  color:"text.subTitle",
                }
              }}
              size="small"
            >
              {languageValues?.myAccount?.changeNames[actLanguage]}
              <KeyboardArrowDownIcon sx={{fontSize:"20px !important", transform:"rotate(-90deg)",}} />
            </Button>
            <Button
              disableRipple
              fullWidth
              onClick={() => { setPage("password") }}
              sx={{
                fontSize:"16px",
                color:"text.black",
                minWidth:0,
                justifyContent:"space-between",
                "&:hover" : {
                  background:"transparent",
                  color:"text.subTitle",
                }
              }}
              size="small"
            >
              {languageValues?.myAccount?.changePassword[actLanguage]}
              <KeyboardArrowDownIcon sx={{fontSize:"20px !important", transform:"rotate(-90deg)",}} />
            </Button>
            <Button
              disableRipple
              fullWidth
              onClick={() => { setPage("language") }}
              sx={{
                fontSize:"16px",
                color:"text.black",
                minWidth:0,
                justifyContent:"space-between",
                "&:hover" : {
                  background:"transparent",
                  color:"text.subTitle",
                }
              }}
              size="small"
            >
              {languageValues?.myAccount?.changeLanguage[actLanguage]}
              <KeyboardArrowDownIcon sx={{fontSize:"20px !important", transform:"rotate(-90deg)",}} />
            </Button>
          </Box>
        </>
      }
      {page === "name" &&
        <PageContainer
          onCloseModal={onCloseModal}
          setPage={setPage}
          title={languageValues?.myAccount?.changeNames[actLanguage]}
          disabledButton={newName?.trim()?.length < 3 || newPoste?.trim()?.length < 3 || changeNamesSubmitting}
          onSave={() => {
            setChangeNamesSubmitting(true)
            APIS.updateAccount({name : newName?.trim(), poste : newPoste?.trim(), language : actLanguage}).then((result) => {
              if (result?.isOk === true) {
                updateUserContext(null, true)
                addPopupNotif({
                  uuid : uuidv4(),
                  title : languageValues?.notifSaveModif[actLanguage],
                  type : "confirm",
                  removeAfter:5000,
                })
              } else {
                addPopupNotif({
                  uuid : uuidv4(),
                  title : languageValues?.notifError[actLanguage],
                  type : "error",
                  removeAfter:5000,
                })
              }
              setChangeNamesSubmitting(false)
            })
          }}
        >
          <Box>
            <Box sx={{textTransform:"uppercase", fontSize:"13px", color:"text.black"}}>
              {languageValues?.myAccount?.name[actLanguage]}
            </Box>
            <TextField
              fullWidth
              margin="normal"
              name="name"
              type="text"
              value={newName}
              placeholder="ex. Paul Durand"
              onChange={(e) => { setNewName(e.target.value) }}
              variant="outlined"
              sx={{
                marginTop:"10px",
              }}
            />
          </Box>
          <Box sx={{paddingTop:"15px"}}>
            <Box sx={{textTransform:"uppercase", fontSize:"13px", color:"text.black"}}>
              {languageValues?.myAccount?.poste[actLanguage]}
            </Box>
            <TextField
              fullWidth
              margin="normal"
              name="poste"
              type="text"
              value={newPoste}
              placeholder="ex. RisingUp"
              onChange={(e) => { setNewPoste(e.target.value) }}
              variant="outlined"
              sx={{
                marginTop:"10px",
              }}
            />
          </Box>
        </PageContainer>
      }
      {page === "password" &&
        <PageContainer
          onCloseModal={onCloseModal}
          setPage={setPage}
          title={languageValues?.myAccount?.changePassword[actLanguage]}
          disabledButton={oldPassword?.trim()?.length < 1 || newPassword?.trim()?.length < 10 || newPassword?.trim() !== newPasswordConfirm.trim() || changePasswordSubmitting}
          onSave={() => {
            setChangePasswordSubmitting(true)
            APIS.updatePassword({oldPassword : oldPassword, newPassword : newPassword}).then((result) => {
              if (result?.message === "ok") {
                setOldPassword("")
                setNewPassword("")
                setNewPasswordConfirm("")
                addPopupNotif({
                  uuid : uuidv4(),
                  title : languageValues?.notifSaveModif[actLanguage],
                  type : "confirm",
                  removeAfter:5000,
                })
              } else if (result?.message === "wrongPassword") {
                addPopupNotif({
                  uuid : uuidv4(),
                  title : languageValues?.myAccount?.wrongOldPassword[actLanguage],
                  type : "error",
                  removeAfter:5000,
                })
              } else {
                addPopupNotif({
                  uuid : uuidv4(),
                  title : languageValues?.notifError[actLanguage],
                  type : "error",
                  removeAfter:5000,
                })
              }
              setChangePasswordSubmitting(false)
            })
          }}

        >
        <Box>
          <Box sx={{textTransform:"uppercase", fontSize:"13px", color:"text.black"}}>
            {languageValues?.myAccount?.oldPassword[actLanguage]}
          </Box>
          <TextField
            fullWidth
            margin="normal"
            name="oldPassword"
            type={showPassword ? "text" : "password"}
            value={oldPassword}
            onChange={(e) => { setOldPassword(e.target.value) }}
            variant="outlined"
            placeholder={languageValues?.myAccount?.changePassword[actLanguage]}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{cursor:"pointer"}} onClick={() => { setShowPassword(!showPassword) }}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              ),
            }}
            sx={{
              marginTop:"10px",
            }}
          />
        </Box>
        <Box sx={{paddingTop:"15px"}}>
          <Box sx={{textTransform:"uppercase", fontSize:"13px", color:"text.black"}}>
            {languageValues?.myAccount?.newPassword[actLanguage]}
          </Box>
          <TextField
            fullWidth
            margin="normal"
            name="newPassword"
            type={showPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => { setNewPassword(e.target.value) }}
            variant="outlined"
            placeholder={languageValues?.myAccount?.newPassword[actLanguage]}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{cursor:"pointer"}} onClick={() => { setShowPassword(!showPassword) }}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              ),
            }}
            sx={{
              marginTop:"10px",
            }}
          />
        </Box>
        <Box sx={{paddingTop:"15px"}}>
          <Box sx={{textTransform:"uppercase", fontSize:"13px", color:"text.black"}}>
            {languageValues?.myAccount?.newPasswordConfirm[actLanguage]}
          </Box>
          <TextField
            fullWidth
            margin="normal"
            name="newPasswordConfirm"
            type={showPassword ? "text" : "password"}
            value={newPasswordConfirm}
            onChange={(e) => { setNewPasswordConfirm(e.target.value) }}
            variant="outlined"
            placeholder={languageValues?.myAccount?.newPassword[actLanguage]}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{cursor:"pointer"}} onClick={() => { setShowPassword(!showPassword) }}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              ),
            }}
            sx={{
              marginTop:"10px",
            }}
          />
        </Box>
        </PageContainer>
      }
      {page === "language" &&
        <PageContainer
          onCloseModal={onCloseModal}
          setPage={setPage}
          title={languageValues?.myAccount?.changeLanguage[actLanguage]}
          noButton
        >
          <Box sx={{
            display:"flex",
            flexDirection:"column",
            gap:"10px"
          }}>
            {allLanguages?.map((lang, index) => {
              let isSelected = actLanguage === lang?.id ? true : false
              return (
                <Box
                  key={index}
                  sx={{
                    border: isSelected ? "1px solid black" : "1px solid #EFEFEF",
                    backgroundColor: isSelected ? "background.grey" : "white",
                    padding:["15px", "20px"],
                    display:"flex",
                    alignItems:"center",
                    userSelect:"none",
                    cursor:"pointer",
                    justifyContent:"space-between",
                  }}
                  onClick={() => {
                    if (changeLanguageSubmitting === false) {
                      setChangeLanguageSubmitting(true)
                      APIS.updateAccount({name : newName?.trim(), poste : newPoste?.trim(), language : lang?.id}).then((result) => {
                        if (result?.isOk === true) {
                          //changeLanguage(lang?.id)
                          updateUserContext(null, true)
                          addPopupNotif({
                            uuid : uuidv4(),
                            title : languageValues?.notifSaveModif[lang?.id],
                            type : "confirm",
                            removeAfter:5000,
                          })
                          setChangeLanguageSubmitting(false)
                        } else {
                          addPopupNotif({
                            uuid : uuidv4(),
                            title : languageValues?.notifError[lang?.id],
                            type : "error",
                            removeAfter:5000,
                          })
                          setChangeLanguageSubmitting(false)
                        }
                      })
                    }
                  }}
                >
                  <Box sx={{
                    display:"flex",
                    alignItems:"center",
                  }}>
                    <Box
                      sx={{
                        width:["20px", "25px"],
                        height:["20px", "25px"],
                        cursor:"pointer",
                        backgroundImage:`url(${lang?.flag})`,
                        backgroundSize:"contain",
                        backgroundRepeat:"no-repeat",
                        backgroundPosition:"center center",
                      }}
                    />
                    <Box sx={{
                      paddingLeft:"15px",
                      color:"text.black",
                      fontSize:["16px", "20px"]
                    }}>
                      {languageValues?.language[lang?.id]}
                    </Box>
                  </Box>
                  {isSelected &&
                    <Box
                      sx={{
                        width:["21px", "26px"],
                        height:["21px", "26px"],
                        cursor:"pointer",
                        backgroundImage:`url(${rectBlackCheckWhite})`,
                        backgroundSize:"contain",
                        backgroundRepeat:"no-repeat",
                        backgroundPosition:"center center",
                      }}
                    />
                  }
                </Box>
              )
            })}
          </Box>
        </PageContainer>
      }
    </>
  )
}


export default MyAccount
